import { createBrowserHistory } from "history";
import { dispatch } from "./../redux/configureStore";

const history = createBrowserHistory();

export default history;
